import React from 'react';

const TypingIndicator = ({ isTyping }) => {
  if (!isTyping) return null;

  return (
    <span className="typing-cursor">|</span>
  );
};

export default TypingIndicator;
